<template>
  <div class="clinic-provider-families">
    <show-provider-family ref="showfamily" @submit="loadFamilies(1)"></show-provider-family>
    <!-- TITLE -->
    <div class="form-group row">
      <div class="col">
        <h1 class="page-title">FAMILIAS DE MATERIALES</h1>
      </div>
    </div>
    <!-- SEARCH BAR -->
    <div class="form-group row">
      <div class="col-md-4">
        <input type="search" class="form-control icon" v-model="search" placeholder="Busca la familia por nombre">
      </div>
      <div class="col-md-8">
        <button type="button" @click="onNewFamily" class="btn btn-wabident-round float-right">
          <i class="fas fa-plus"></i>
          Nueva Familia &hellip;
        </button>
      </div>
    </div>

    <!-- RESULTS -->
    <div v-if="has_results" class="form-group row">
      <div class="col-12">
        <table class="table table-search-results">
          <thead>
            <tr class="table-search-results__row">
              <th>ID</th>
              <th>FAMILIA</th>
              <th>CATEGORÍA</th>
            </tr>
          </thead>
          <tbody>

            <tr class="table-search-results__row" v-for="family in results.data" :index="family.id"
              @click="$refs.showfamily.showEdit(family)">
              <td>{{ family.id }}</td>
              <td>{{ family.name }}</td>
              <td>{{ family.category }}</td>
            </tr>

          </tbody>
        </table>
      </div>
      <div class="col-12 my-4">
        <data-pagination :disabled="is_searching" @gotopage="loadFamilies" :page="results.current_page"
          :total="results.last_page"></data-pagination>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      results: null,
      is_searching: false,
    };
  },
  computed: {
    has_results() {
      return this.results && this.results.data;
    },
    ...mapGetters(['clinic', 'errorwindow', 'msgwindow'])
  },
  watch: {
    search(v) {
      this.loadFamilies();
    },
  },
  methods: {
    loadFamilies(page = 1) {
      if (this.is_searching) {
        return;
      }

      this.is_searching = true;
      const params = {
        search: this.search,
        page: page
      };

      axios.get(`/family`, { params }).then((response) => {
        this.results = response.data;
      }).catch((error) => {
        this.msgwindow.error('Error listando Familias. Por favor, contacta con el Administrador');
      }).then(() => {
        this.is_searching = false;
      });
    },
    onNewFamily() {
      this.$refs.showfamily.showNew();
    },
  },
  mounted() {
    this.loadFamilies();
  }
}
</script>

<style>
.clinic-provider-families {
  margin-top: 52px;
}
</style>
